export default __webpack_public_path__ + "static/media/explore.992eb384.png";